/* tslint:disable */
/* eslint-disable */
export enum WorkMessagingTemplateNameEnum {
  ObBestaetigung = 'ob_bestaetigung',
  ObErinnerung = 'ob_erinnerung',
  ObStornierung = 'ob_stornierung',
  ObTerminassistent = 'ob_terminassistent',
  Speicherinformation = 'speicherinformation',
  SpeicherinformationSolaredge = 'speicherinformation_solaredge',
  Terminbestaetigung = 'terminbestaetigung',
  TerminbestaetigungMitVerantwortlichem = 'terminbestaetigung_mit_verantwortlichem',
  Zahlungserinnerung = 'zahlungserinnerung',
  MitarbeiterWillkommenstext = 'mitarbeiter_willkommenstext',
  Drittkontrolle = 'drittkontrolle',
  ProjektPlanungsunterlagen = 'projekt_planungsunterlagen',
  MaengelberichtBehoben = 'maengelbericht_behoben',
  IaEinreichen = 'ia_einreichen',
  SinaErstellen = 'sina_erstellen',
  AcDcSinaErstellen = 'ac_dc_sina_erstellen',
  InfoZumArtikel = 'info_zum_artikel',
  KontaktArchivStornierung = 'kontakt_archiv_stornierung',
  ProjektStorno = 'projekt_storno',
  ProjektFreigabe = 'projekt_freigabe',
  ProjektBestellbestaetigung = 'projekt_bestellbestaetigung',
  ProbezeitAblaufVorgesetzter = 'probezeit_ablauf_vorgesetzter'
}
